export const LOCAL_STORAGE_KEYS = {
  K8S_LENS_TIME_RANGE: "k8s-lens-time-range",
};
